// SUN RAY — Global JS
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    // Mobile menu toggle (open button, close button, overlay all have data-mobile-toggle)
    var mobileToggles = document.querySelectorAll('[data-mobile-toggle]');
    var mobileMenu = document.querySelector('[data-mobile-menu]');
    if (mobileToggles.length && mobileMenu) {
      mobileToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          mobileMenu.classList.toggle('is-open');
          document.body.classList.toggle('menu-open');
          var isOpen = mobileMenu.classList.contains('is-open');
          mobileMenu.setAttribute('aria-hidden', !isOpen);
        });
      });
    }

    // Accordions (product page, FAQs)
    var accordions = document.querySelectorAll('[data-accordion]');
    accordions.forEach(function (accordion) {
      var triggers = accordion.querySelectorAll('[data-accordion-trigger]');
      triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var content = trigger.nextElementSibling;
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', !isOpen);
          if (content) {
            if (!isOpen) {
              content.style.maxHeight = content.scrollHeight + 'px';
            } else {
              content.style.maxHeight = '0px';
            }
          }
        });
      });
    });

    // Simple carousel (testimonials, reviews)
    var carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;
      var scrollAmount = track.offsetWidth * 0.8;
      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }
    });

    // Add to cart (product page)
    var atcForms = document.querySelectorAll('[data-atc-form]');
    atcForms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('[type="submit"]');
        if (btn) {
          btn.textContent = 'Adding...';
          btn.disabled = true;
        }
      });
    });
  });
})();
